import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { Text } from "web/react/emo/text";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./retailer-with-logo.css";

export interface RetailerWithLogoProps {
    retailerName: string;
    retailerLogoURL?: string;
    isVerified?: boolean;
}

export function RetailerWithLogo({
    retailerName,
    retailerLogoURL,
    isVerified = false,
}: RetailerWithLogoProps): React.ReactElement {
    return (
        <div className={styles.container}>
            {retailerLogoURL && (
                <img
                    src={retailerLogoURL}
                    className={styles.retailerLogo}
                    alt={`${retailerName}-logo`}
                />
            )}
            <Text className={styles.retailerName} textStyle="body-xs" truncate lineLimit={1}>
                {gettext("in_stock_product.from_retailer", { retailer_name: retailerName })}
            </Text>
            {isVerified && <SVGIcon className={styles.verifiedIcon} name="verified" />}
        </div>
    );
}
